export function StylistCard({ stylist }) {
  return (
    <div className="p-3 w-[400px] bg-[#f0eff5] rounded-lg justify-start items-center gap-[9px] flex">
      <div className="w-[41px] h-[41px] rounded-full">
        <img
          className="w-full h-full rounded-full"
          src={stylist?.profileImg}
          alt="profile"
        />
      </div>
      <div className="flex-col justify-start items-start gap-0.5 flex">
        <div className="text-black text-sm font-normal poppins">
          {stylist?.fullName}
        </div>
        <div className="opacity-40 text-black text-[13px] font-normal poppins">
          @{stylist?.username}
        </div>
      </div>
    </div>
  );
}
